<template>
  <div class="w-100">
    <div
      v-if="client && eoc"
      class="
        top-bar-container
        d-flex
        flex-row
        justify-content-between
        align-items-center
        p-1
        bg-extra-light-gray
        text-black
      "
    >
      <div
        class="
          d-flex
          flex-row
          justify-content-start
          client-data
          align-items-center
          color-custom-dark-grey
        "
      >
        <div class="search-container">
          <b-form-input
            v-model="search"
            size="sm"
            class="search-input border-light-grey"
            placeholder="Search..."
          ></b-form-input>
        </div>
        <div
          class="client-avatar picture-preview"
          style="width: 55px; height: 55px"
        >
          <img
            :src="
              client && client.avatar
                ? client.avatar
                : require(`../../assets/avatar-example.png`)
            "
          />
        </div>
        <div>
          <div
            class="
              ml-2
              mt-1
              patient-top-bar-data-general
              d-flex
              justify-content-start
              align-items-center
              flex-wrap
            "
          >
            <div class="mx-2 font-weight-bold">
              {{ { mrn: client.mrn, eocn: eoc.eocn } | formatMrn }}
            </div>
            |
            <div class="mx-2 font-weight-bold">
              {{ client | formatClient }}
            </div>
            <b-badge
              :variant="statusVariant"
              pill
              class="mx-2 px-3 text-white status-badge"
              >{{ statusText }}
            </b-badge>
          </div>
          <div
            class="
              ml-2
              mt-1
              d-flex
              justify-content-start
              align-items-center
              flex-wrap
            "
          >
            <span v-if="client.gender" class="mx-2 patient-top-bar-data">
              {{ client.gender.name }}
            </span>
            {{ client.gender ? "|" : "" }}
            <span class="mx-2 patient-top-bar-data">
              DOB {{ client.dateOfBirth | formatDateOnly }}
            </span>
            |
            <span class="mx-2 patient-top-bar-data">
              {{ client.dateOfBirth | getAge }} years
            </span>
            {{ locations.length > 0 ? "|" : "" }}
            <span v-if="locations.length > 0" class="mx-2 patient-top-bar-data">
              Location: {{ eoc.location ? eoc.location.name : "Not selected" }}
            </span>
            {{ eoc.levelOfCare ? "|" : "" }}
            <span v-if="eoc.levelOfCare" class="mx-2 patient-top-bar-data">
              Current LOC:
              {{ eoc.levelOfCare.name }}
            </span>
            {{ eoc.services && eoc.services.length > 0 ? "|" : "" }}
            <span
              v-if="eoc.services && eoc.services.length > 0"
              class="mx-2 patient-top-bar-data"
            >
              Services Today:
              {{ eoc.services.join(", ") }}
            </span>
            {{ eoc.startDate ? "|" : "" }}
            <span v-if="eoc.startDate" class="mx-2 patient-top-bar-data">
              Start/Admission Date:
              {{ eoc.startDate | formatDate }}
            </span>
            {{ eoc.endDate ? "|" : "" }}
            <span v-if="eoc.endDate" class="mx-2 patient-top-bar-data">
              EOC End:
              {{ eoc.endDate | formatDate }}
            </span>
          </div>
        </div>
      </div>
      <div>
        <b-dropdown
          variant="info"
          right
          class="mr-4"
          toggle-class=""
          size="sm"
          v-if="eoc"
        >
          <template #button-content>
            <i class="fa fa-cog mr-2" aria-hidden="true"></i> Options
          </template>
          <b-dropdown-item
            v-if="hasCurrentUserPermissionAccess('patients', 'create')"
            @click="editEoc"
            style="font-size:14px;"
          >
            <i
              class="fa fa-pencil-square-o"
              aria-hidden="true"
              style="width:17px;"
            ></i>
            Edit Patient/EOC
          </b-dropdown-item>
          <b-dropdown-header class="bg-extra-light-gray">
            Patient Status
          </b-dropdown-header>
          <b-dropdown-item
            variant="warning"
            @click="changeStatus('Pending')"
            :disabled="eoc.status == 'Pending'"
            style="font-size:14px;"
            ><i class="fa fa-user" aria-hidden="true" style="width:17px;"></i>
            Pending
          </b-dropdown-item>
          <b-dropdown-item
            variant="success"
            @click="changeStatus('Active')"
            :disabled="eoc.status == 'Active'"
            style="font-size:14px;"
            ><i class="fa fa-user" aria-hidden="true" style="width:17px;"></i>
            Active
          </b-dropdown-item>
          <b-dropdown-item
            variant="danger"
            @click="$refs['form-end-modal'].show()"
            :disabled="eoc.status == 'Inactive'"
            style="font-size:14px;"
            ><i class="fa fa-user" aria-hidden="true" style="width:17px;"></i>
            Inactive/Discharge
          </b-dropdown-item>
          <b-dropdown-item
            @click="showSendPatientPortalLinkModal = true"
            :disabled="eoc.status == 'Inactive'"
            style="font-size:14px;"
            ><i class="fa fa-link" aria-hidden="true" style="width:17px;"></i>
            Send Patient Portal Link
          </b-dropdown-item>
          <b-dropdown-header class="bg-extra-light-gray">
            Documents
          </b-dropdown-header>
          <b-dropdown-item
            @click="showDocumentSharingModal = true"
            style="font-size:14px;"
          >
            <i
              class="fa fa-paper-plane"
              aria-hidden="true"
              style="width:17px;"
            ></i>
            Doc. Request/Sharing
          </b-dropdown-item>
<!--          <b-dropdown-item-->
<!--            @click="showAllDocumentsModal = true"-->
<!--            style="font-size:14px;"-->
<!--          >-->
<!--            <i-->
<!--              class="fa fa-file-text"-->
<!--              aria-hidden="true"-->
<!--              style="width:17px;"-->
<!--            ></i>-->
<!--            All Documents-->
<!--          </b-dropdown-item>-->
          <b-dropdown-header class="bg-extra-light-gray">
            Reports
          </b-dropdown-header>
          <b-dropdown-item
            v-if="hasCurrentUserReportPermission('PatientSummary')"
            @click="showReportModal = true"
            style="font-size:14px;"
          >
            <i
              class="fa fa-file-text"
              aria-hidden="true"
              style="width:17px;"
            ></i>
            Patient Summary
          </b-dropdown-item>
          <b-dropdown-item
            v-if="
              currentUser && currentUser.hasPMPAccess && systemSetting.pmpEnable
            "
            @click="checkPmpInfo"
            style="font-size:14px;"
          >
            <i
              class="fa fa-file-text"
              aria-hidden="true"
              style="width:17px;"
            ></i>
            Check PMP Information
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="d-flex content-container justify-content-start w-100">
      <div
        class="
          left-sidebar
          d-flex
          flex-column
          justify-content-between
          border-color-light-gray
        "
        :style="`height: calc(100vh - ${tabsHeight + 145}px);`"
      >
        <div class="w-100">
          <div v-for="sidebarItem in sidebarItemsFilter" :key="sidebarItem.key">
            <div
              v-if="
                showComingSoon || sidebarItem.component.name != 'ComingSoon'
              "
              @click="addSectionTab(sidebarItem)"
              class="
                sidebar-menu-item
                d-flex
                flex-row
                justify-content-between
                align-items-center
                w-100
                color-black color-custom-dark-grey
              "
            >
              <div class="d-flex flex-row align-items-center">
                <i
                  class="fa ml-2"
                  :class="'fa-' + sidebarItem.icon"
                  aria-hidden="true"
                  style="width: 20px"
                ></i>
                <span class="ml-2">{{ sidebarItem.text }} </span>
              </div>
            </div>
          </div>
          <div>
            <div
              class="
                sidebar-menu-item-label
                d-flex
                flex-row
                justify-content-between
                align-items-center
                w-100
                color-black
                px-3
                py-2
                bg-white
                color-custom-dark-grey
              "
            >
              <div class="d-flex flex-row align-items-center">
                <span class="ml-2">Documents </span>
              </div>
            </div>
          </div>
          <eoc-view-documents-sidebar
            :menus="menusTree"
            @add-tab="addTab"
            :firstLevel="true"
          />
        </div>
      </div>
      <div
        class="main-content border-top border-left bg-transparent"
        :style="`height: calc(100vh - ${tabsHeight + 118}px);`"
      >
        <tabs
          :tabs="tabs"
          :selectedTab="selectedTab"
          :bgClass="'bg-white'"
          :borderClass="'border-color-light-gray bordered-tab-item'"
          :itemTextClass="'color-custom-dark-grey'"
          :itemBGClass="'bg-dark-gray'"
          :componentsClass="'left-white-border'"
          @select-tab="selectTab"
          @remove-tab="removeTab"
          @add-tab="addTab"
          @tabs-container-height-change="setTabsContainerHeight"
          @change-transfer-to-mars="toggleTransferToMars"
          :showing="showing"
          ref="tabs"
        />
      </div>
    </div>
    <b-modal
      centered
      ref="form-end-modal"
      title="End Episode of Care"
      header-bg-variant="danger"
      header-text-variant="white"
      @ok="submitEndEOC"
      no-close-on-backdrop
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()"> Cancel</b-button>
        <b-button variant="danger" @click="ok()"> End EOC</b-button>
      </template>
      <b-form-group
        label="End Date"
        :state="formEndErrors.endDate.length == 0 ? null : false"
        :invalid-feedback="formEndErrors.endDate.join(', ')"
      >
        <date-time-picker
          v-model="formEnd.endDate"
          :maxDate="getCurrentAdjustedDateTime()"
          :errors="formEndErrors.endDate"
        />
      </b-form-group>
      <b-form-group
        label="Discharge Reason"
        :state="formEndErrors.dischargeReason.length == 0 ? null : false"
        :invalid-feedback="formEndErrors.dischargeReason.join(', ')"
      >
        <template v-slot:label> Discharge Reason*</template>
        <v-select
          v-model="formEnd.dischargeReason"
          :options="dischargeReasons"
        ></v-select>
      </b-form-group>
      <b-form-group
        label="Other reason"
        v-if="
          formEnd.dischargeReason
            ? formEnd.dischargeReason.label.toLowerCase() == 'other'
            : false
        "
      >
        <b-form-input
          v-model="formEnd.otherDischargeReason"
          maxLength="100"
          placeholder="Other discharge reason"
        ></b-form-input>
      </b-form-group>
    </b-modal>
    <send-patient-portal-link-modal
      v-if="showSendPatientPortalLinkModal"
      v-model="showSendPatientPortalLinkModal"
      :patientId="clientId"
    />
    <eoc-add-edit-modal
      v-if="showEditClientEditor"
      v-model="showEditClientEditor"
      :clientId="clientId"
      :eocId="eocId"
      @onModify="onModifyEditClient"
      @remove-current-tab="removeCurrentTab"
    />
    <report-modal
      v-if="showReportModal"
      v-model="showReportModal"
      title="Patient Summary"
      report="patientSummary"
      :filter="{ EpisodeOfCareId: eocId }"
    />
    <eoc-view-all-documents-modal
      v-if="showAllDocumentsModal"
      v-model="showAllDocumentsModal"
      :eocId="eocId"
    />
    <document-view-modal
      v-if="documentViewModal.show"
      v-model="documentViewModal.show"
      :documentId="documentViewModal.id"
      @onEdit="openDocumentEditor"
    />
    <document-file-add-edit-modal
      v-if="documentEditor.showFileEditor"
      v-model="documentEditor.showFileEditor"
      :formId="documentEditor.formId"
      :eocId="documentEditor.eocId"
      :clientId="documentEditor.patientId"
      :submitId.sync="documentEditor.documentId"
      @onModify="onModifyDocument"
    />
    <document-add-edit-modal
      v-if="documentEditor.showDocumentEditor"
      v-model="documentEditor.showDocumentEditor"
      :formId="documentEditor.formId"
      :eocId="documentEditor.eocId"
      :clientId="documentEditor.patientId"
      :submitId="documentEditor.documentId"
      @onModify="onModifyDocument"
    />
    <document-group-add-edit-modal
      v-if="documentEditor.showDocumentGroupEditor"
      v-model="documentEditor.showDocumentGroupEditor"
      :formGroupId="documentEditor.formGroupId"
      :eocId="documentEditor.eocId"
      :clientId="documentEditor.patientId"
      :submitId="documentEditor.documentId"
      @onModify="onModifyDocument"
    />
    <document-sharing-modal
      v-if="showDocumentSharingModal"
      v-model="showDocumentSharingModal"
      :eocId="eocId"
      :patientId="clientId"
      @viewDocument="viewDocument"
    />
    <eoc-pmp-modal
      v-if="showPmpPatientRequestModal"
      v-model="showPmpPatientRequestModal"
      :reportRequestURLs="reportRequestURLs"
      :narxScores="narxScores"
      :narxMessages="narxMessages"
      :eocId="eocId"
    />
  </div>
</template>

<script>
import { formatDateTimeMysql, formatDateTimeSql } from "../../helpers/date";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import avatarServer from "../../server/avatar";
import catalogServer from "../../server/catalog";
import eocServer from "../../server/eoc";
import patientServer from "../../server/patient";
import formSubmitterServer from "../../server/formSubmitter";
import pmpServer from "../../server/pmp";
import { validateRequired, validateDateTime } from "../../helpers/validation";
import EocViewSummary from "./EocViewSummary.vue";
import EocViewBadgesAlerts from "./EocViewBadgesAlerts.vue";
import EocViewVitals from "./EocViewVitals.vue";
import EocViewDiagnosisCodes from "./EocViewDiagnosisCodes.vue";
import EocViewNutritionalJournal from "./EocViewNutritionalJournal.vue";
import EocAddEditModal from "./EocAddEditModal";
import EocViewDocumentsSidebar from "./EocViewDocumentsSidebar.vue";
import EocViewMedications from "./EocViewMedications.vue";
import EocViewOmt from "./EocViewOmt.vue";
import EocViewCalendar from "./EocViewCalendar.vue";
import SendPatientPortalLinkModal from "./SendPatientPortalLinkModal.vue";
import EocViewTreatmentPlanDocuments from "./EocViewTreatmentPlanDocuments";
import EocViewDoctorOrderDocuments from "./EocViewDoctorOrderDocuments";
import EocViewReleaseOfInformationDocuments from "./EocViewReleaseOfInformationDocuments";
import PatientDoseSpot from "./PatientDoseSpot";
import Tabs from "../workspace/Tabs.vue";
import DateTimePicker from "../controls/DateTimePicker";
import ReportModal from "../report/ReportModal.vue";
import EocViewAllDocumentsModal from "./EocViewAllDocumentsModal.vue";
import DocumentViewModal from "./document/DocumentViewModal.vue";
import DocumentFileAddEditModal from "./document/DocumentFileAddEditModal.vue";
import DocumentAddEditModal from "./document/DocumentAddEditModal.vue";
import DocumentGroupAddEditModal from "./document_group/DocumentGroupAddEditModal.vue";
import DocumentSharingModal from "./document_sharing/DocumentSharingModal.vue";
import EocPmpModal from "./EocPmpModal";
import locationServer from "../../server/location";

const buildTree = (rootMenu, menus, search, hasAccess) => {
  const treeNodes = [];
  for (let index = 0; index < menus.length; index++) {
    const menu = menus[index];
    if (menu.parentId == rootMenu.id) {
      const children = buildTree(menu, menus, search, hasAccess);
      if (!search || children.length > 0) {
        treeNodes.push({
          name: menu.name,
          id: menu.id,
          isLeaf: false,
          children: children
        });
      }
    }
  }
  for (let index = 0; index < rootMenu.items.length; index++) {
    const item = rootMenu.items[index];
    if (
      (!search || item.name.toLowerCase().indexOf(search.toLowerCase()) >= 0) &&
      hasAccess(item.objectId, "isReadOnly")
    ) {
      treeNodes.push({
        name: item.name,
        id: (item.type == "Form" ? "f" : "g") + "-" + item.objectId,
        isLeaf: true
      });
    }
  }
  return treeNodes;
};

const chartSummary = {
  key: "chart",
  icon: "tachometer-alt",
  text: "Summary",
  component: EocViewSummary
};

export default {
  name: "EocView",
  components: {
    DateTimePicker,
    EocAddEditModal,
    EocViewDocumentsSidebar,
    Tabs,
    ReportModal,
    EocViewAllDocumentsModal,
    DocumentViewModal,
    DocumentFileAddEditModal,
    DocumentAddEditModal,
    DocumentGroupAddEditModal,
    DocumentSharingModal,
    SendPatientPortalLinkModal,
    EocPmpModal
  },
  props: ["clientId", "eocId", "showing", "tabsHeight"],
  data() {
    return {
      client: null,
      formEnd: {
        endDate: formatDateTimeMysql(),
        dischargeReason: null,
        otherDischargeReason: null
      },
      formEndErrors: {
        endDate: [],
        dischargeReason: []
      },
      eoc: null,
      sidebarItems: [
        chartSummary,
        {
          key: "calendar",
          icon: "calendar",
          text: "Patient Calendar",
          component: EocViewCalendar,
          condition: () =>
            this.hasCurrentUserPermissionAccess("patients", "calendar")
        },
        {
          key: "badgesAlerts",
          icon: "bell",
          text: "Badges/Alerts",
          component: EocViewBadgesAlerts,
          condition: () =>
            this.hasCurrentUserPermissionAccess("patients", "badgesAlerts")
        },
        {
          key: "diagnosisCodes",
          icon: "medkit",
          text: "Diagnosis Codes",
          component: EocViewDiagnosisCodes,
          condition: () =>
            this.hasCurrentUserPermissionAccess("patients", "diagnosisCodes")
        },
        {
          key: "vitals",
          icon: "heartbeat",
          text: "Vitals",
          component: EocViewVitals,
          condition: () =>
            this.hasCurrentUserPermissionAccess("patients", "vitals")
        },
        {
          key: "nutritionalJournal",
          icon: "utensils",
          text: "Nutritional Journal",
          component: EocViewNutritionalJournal,
          condition: () =>
            this.hasCurrentUserPermissionAccess(
              "patients",
              "nutritionalJournal"
            )
        },
        {
          key: "medications",
          icon: "pills",
          text: "Medications",
          component: EocViewMedications,
          condition: () =>
            this.hasCurrentUserPermissionAccess("patients", "medications") &&
            !this.isEMAREnabled
        },
        {
          key: "omt",
          icon: "file-text",
          text: "Outcome Measurement Tools",
          component: EocViewOmt,
          condition: () =>
            this.hasCurrentUserPermissionAccess("patients", "omt")
        },
        {
          key: "masterTreatmentPlan",
          icon: "file-text",
          text: "Treatment Plans",
          component: EocViewTreatmentPlanDocuments,
          condition: () =>
            this.hasCurrentUserPermissionAccess(
              "patients",
              "masterTreatmentPlan"
            )
        },
        {
          key: "doctorOrder",
          icon: "pills",
          text: "Doctor Orders",
          component: EocViewDoctorOrderDocuments,
          condition: () =>
            this.hasCurrentUserPermissionAccess("patients", "doctorOrder") &&
            this.systemSetting.doctorOrderEnabled &&
            !this.isEMAREnabled
        },
        {
          key: "releaseOfInformation",
          icon: "file-text",
          text: "Releases Of Information (ROIs)",
          component: EocViewReleaseOfInformationDocuments,
          condition: () =>
            this.hasCurrentUserPermissionAccess(
              "patients",
              "releaseOfInformation"
            )
        },
        {
          key: "doseSpot",
          icon: "capsules",
          text: "E-Prescribe",
          component: PatientDoseSpot,
          condition: () =>
            this.isDoseSpotActive &&
            this.hasCurrentUserPermissionAccess("patients", "ePrescribe") &&
            this.currentUser.doseSpotId
        }
      ],
      showEditClientEditor: false,
      menus: [],
      search: "",
      tabs: [],
      selectedTab: chartSummary.key,
      tabsContainerHeight: 0,
      showReportModal: false,
      showAllDocumentsModal: false,
      documentViewModal: { show: false, id: null },
      documentEditor: {
        showFileEditor: false,
        showDocumentEditor: false,
        showDocumentGroupEditor: false,
        documentId: null,
        formId: null,
        formGroupId: null,
        patientId: null,
        eocId: null
      },
      showDocumentSharingModal: false,
      showSendPatientPortalLinkModal: false,
      dischargeReason: null,
      showPmpPatientRequestModal: false,
      reportRequestURLs: null,
      narxMessages: [],
      narxScores: [],
      locationEoc: null
    };
  },
  mounted() {
    eocServer.logEocViewed(this.eocId);
    this.formEnd.endDate = formatDateTimeMysql(
      this.getCurrentAdjustedDateTime()
    );
    this.fetchFormBuilderForms({ category: "main" });
    this.fetchDischargeReasons();
    this.fetchFormGroups();
    this.getClient();
    this.getMenus();

    this.tabs.push({
      key: chartSummary.key,
      text: chartSummary.text,
      component: chartSummary.component,
      props: {
        clientId: this.clientId,
        eocId: this.eocId
      },
      closeable: false
    });
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    ...mapActions("formGroup", ["fetchFormGroups"]),
    ...mapActions("client", ["fetchDischargeReasons"]),
    ...mapMutations("client", ["dispatchListener"]),
    async getClient() {
      const client = await patientServer.get(this.clientId);
      try {
        if (client.avatarId)
          client.avatar = await avatarServer.downloadUrl(client.avatarId);
      } catch {
        client.avatar = require(`../../assets/avatar-example.png`);
      }
      this.client = client;
      const eoc = await eocServer.get(this.eocId);
      this.eoc = eoc;
      const location = await locationServer.get(this.eoc.location.id);
      this.locationEoc = location;
      this.$emit("update-current-tab", {
        key: "eoc-" + eoc.id,
        text: this.formatEocObj(eoc),
        props: {
          eocId: eoc.id,
          clientId: eoc.patient.id
        }
      });
    },
    dispatchFetchClient() {
      this.dispatchListener({ listener: "fetchClient", param: this.clientId });
    },
    editEoc() {
      this.showEditClientEditor = true;
    },
    validateEndEOC() {
      let withoutErrors = true;

      this.formEndErrors.endDate = [];
      if (!validateRequired(this.formEnd.endDate)) {
        this.formEndErrors.endDate.push("This field is required");
        withoutErrors = false;
      }

      if (this.formEnd.endDate && !validateDateTime(this.formEnd.endDate)) {
        this.formEndErrors.endDate.push(
          "This field must have a valid date format"
        );
        withoutErrors = false;
      }

      this.formEndErrors.dischargeReason = [];
      if (!validateRequired(this.formEnd.dischargeReason)) {
        this.formEndErrors.dischargeReason.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitEndEOC(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateEndEOC();
      if (result) {
        await eocServer.end(this.eoc.id, {
          endDate: formatDateTimeSql(this.formEnd.endDate),
          dischargeReasonId: this.formEnd.dischargeReason.value,
          otherDischargeReason: this.formEnd.otherDischargeReason
        });
        this.dispatchFetchEoc();
        this.showAlertSuccess();
        this.$refs["form-end-modal"].hide();
      }
    },
    removeCurrentTab() {
      this.$emit("remove-current-tab");
    },
    onModifyEditClient() {
      this.showEditClientEditor = false;
      //this.dispatchFetchClient();
      this.dispatchFetchEoc();
    },
    async getMenus() {
      const menus = await catalogServer.getMenus();
      this.menus = menus;
    },
    selectTab(selectedTab) {
      this.selectedTab = selectedTab;
    },
    removeTab(tabIndex) {
      if (this.tabs[tabIndex].key == this.selectedTab) {
        if (tabIndex < this.tabs.length - 1) {
          this.selectedTab = this.tabs[tabIndex + 1].key;
        } else {
          this.selectedTab = this.tabs[tabIndex - 1].key;
        }
      }
      const newTabs = [...this.tabs];
      newTabs.splice(tabIndex, 1);
      this.tabs = newTabs;
    },
    addTab(tabItem) {
      if (this.tabs.map(tab => tab.key).indexOf(tabItem.id) == -1) {
        const newTabs = [...this.tabs];
        newTabs.push({
          key: tabItem.id,
          text: tabItem.text,
          component: tabItem.component,
          props: {
            ...tabItem.elementData,
            clientId: this.clientId,
            eocId: this.eocId,
            transferToMarsValue: this.eoc.transferMedicationsToMars,
            location: this.locationEoc
          },
          closeable: true
        });
        this.tabs = newTabs;
      }
      this.selectedTab = tabItem.id;
    },
    setTabsContainerHeight(newHeight) {
      this.tabsContainerHeight = newHeight;
    },
    addSectionTab(sidebarItem) {
      this.addTab({
        id: sidebarItem.key,
        text: sidebarItem.text,
        component: sidebarItem.component,
        elementData: {}
      });
    },
    dispatchFetchEoc() {
      this.dispatchListener({ listener: "fetchEoc", param: this.eocId });
      this.dispatchListener({ listener: "fetchEoc", param: "all" });
    },
    changeStatus(newStatus) {
      let statusLabel = '<span class="text-success">Active</span>';
      if (newStatus == "Pending")
        statusLabel = '<span class="text-warning">Pending</span>';
      this.$dialog
        .confirm(
          {
            title: `Are you sure you want to change the patient's status to ${statusLabel}?`
          },
          {
            view: "confirm"
          }
        )
        .then(async () => {
          await eocServer.changeStatus(this.eocId, newStatus);
          this.dispatchFetchEoc();
          this.showAlertSuccess();
        })
        .catch(function() {});
    },
    async viewDocument(documentId) {
      const document = await formSubmitterServer.getDetailedImproved(
        documentId
      );

      if (document.mode == "File") {
        const url = formSubmitterServer.viewUrl(documentId);
        window.open(url, "_blank");
      } else {
        this.documentViewModal = { show: true, id: documentId };
      }
    },
    openDocumentEditor(record) {
      if (record.mode == "File") {
        this.documentEditor.showFileEditor = true;
        this.documentEditor.documentId = record.documentId;
        this.documentEditor.patientId = record.patient.id;
        this.documentEditor.eocId = record.episodeOfCare.id;
        this.documentEditor.formId = record.form.id;
      } else if (record.type == "Document") {
        this.documentEditor.showDocumentEditor = true;
        this.documentEditor.documentId = record.documentId;
        this.documentEditor.patientId = record.patient.id;
        this.documentEditor.eocId = record.episodeOfCare.id;
        this.documentEditor.formId = record.form.id;
      } else {
        this.documentEditor.showDocumentGroupEditor = true;
        this.documentEditor.documentId = record.documentId;
        this.documentEditor.patientId = record.patient.id;
        this.documentEditor.eocId = record.episodeOfCare.id;
        this.editDocumentGroup.formGroupId = record.form.id;
      }

      this.showDocumentViewModal = { show: false, id: null };
    },
    onModifyDocument() {
      this.documentEditor.showFileEditor = false;
      this.documentEditor.showDocumentEditor = false;
      this.documentEditor.showDocumentGroupEditor = false;
      this.showAlertSuccess();
      this.dispatchFetchEoc();
    },
    async toggleTransferToMars(newValue) {
      await eocServer
        .updateTransferMedicationsToMars(this.eocId, newValue)
        .then(() => {
          this.tabs.forEach(tab => {
            if (tab.props.transferToMarsValue != undefined)
              tab.props.transferToMarsValue = newValue;
          });
          this.eoc.transferMedicationsToMars = newValue;
        });
    },
    checkPmpInfo() {
      pmpServer.requestPatient(this.eocId).then(resp => {
        if (resp.error?.message) {
          this.showError({
            message: resp.error?.message
          });
        } else {
          this.reportRequestURLs = resp.report.reportRequestURLs.reportUrls;
          this.narxMessages = resp.report.narxMessages;
          this.narxScores = resp.report.narxScores;
          this.showPmpPatientRequestModal = true;
        }
      });
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    ...mapGetters("layout", [
      "hasCurrentUserPermissionAccess",
      "hasCurrentUserReportPermission"
    ]),
    ...mapGetters("client", ["listeners"]),
    ...mapState("layout", {
      isDoseSpotActive: state => state.isDoseSpotActive,
      systemSetting: state => state.systemSetting,
      currentUser: state => state.currentUser,
      isEMAREnabled: state => state.systemSetting?.emarEnabled
    }),
    ...mapState("client", {
      locations: state =>
        state.locations.map(location => ({
          value: location.id,
          label: location.name
        })),
      genders: state =>
        state.genders.map(gender => ({
          value: gender.id,
          label: gender.name
        })),
      maritalStatuses: state =>
        state.maritalStatuses.map(maritalStatus => ({
          value: maritalStatus.id,
          label: maritalStatus.name
        })),
      states: state =>
        state.states.map(state => ({
          value: state.id,
          label: state.name
        })),
      dischargeReasons: state =>
        state.dischargeReasons.map(reason => ({
          value: reason.id,
          label: reason.name
        }))
    }),
    ...mapGetters("client", ["levelsOfCareCurrentLocation"]),
    levelsOfCare() {
      return this.levelsOfCareCurrentLocation.map(levelOfCare => ({
        value: levelOfCare.id,
        label: levelOfCare.name
      }));
    },
    ...mapGetters("client", ["formsCurrentLocation"]),
    ...mapGetters("client", ["formGroupsCurrentLocation"]),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    levelOfCare: {
      get() {
        return this.form.levelOfCareId
          ? this.levelsOfCare.find(
              levelOfCare => levelOfCare.value == this.form.levelOfCareId
            )
          : null;
      },
      set(newValue) {
        this.form.levelOfCareId = newValue ? newValue.value : null;
      }
    },
    location: {
      get() {
        return this.form.locationId
          ? this.locations.find(
              location => location.value == this.form.locationId
            )
          : null;
      },
      set(newValue) {
        this.form.locationId = newValue ? newValue.value : null;
      }
    },
    gender: {
      get() {
        return this.formClient.genderId
          ? this.genders.find(
              gender => gender.value == this.formClient.genderId
            )
          : null;
      },
      set(newValue) {
        this.formClient.genderId = newValue ? newValue.value : null;
      }
    },
    maritalStatus: {
      get() {
        return this.formClient.maritalStatusId
          ? this.maritalStatuses.find(
              maritalStatus =>
                maritalStatus.value == this.formClient.maritalStatusId
            )
          : null;
      },
      set(newValue) {
        this.formClient.maritalStatusId = newValue ? newValue.value : null;
      }
    },
    state: {
      get() {
        return this.formClient.stateId
          ? this.states.find(state => state.value == this.formClient.stateId)
          : null;
      },
      set(newValue) {
        this.formClient.stateId = newValue ? newValue.value : null;
      }
    },
    showComingSoon() {
      return JSON.parse(process.env.VUE_APP_SHOW_COMING_SOON);
    },
    menusTree() {
      const locationFormIds = this.formsCurrentLocation.map(form => form.id);
      const locationFormGroupIds = this.formGroupsCurrentLocation.map(
        formGroup => formGroup.id
      );
      const filteredMenus = this.menus.map(menu => {
        const items = menu.items.filter(item => {
          if (item.type == "Form") {
            if (locationFormIds.includes(item.objectId)) {
              return true;
            }
          }
          if (item.type == "FormGroup") {
            if (locationFormGroupIds.includes(item.objectId)) {
              return true;
            }
          }
          return false;
        });
        return {
          ...menu,
          items
        };
      });
      if (!this.search) {
        const rootMenu = filteredMenus.find(menu => !menu.parentId);
        if (rootMenu) {
          return buildTree(
            rootMenu,
            filteredMenus,
            "",
            this.hasCurrentUserDocumentPermission
          );
        }
      }
      const menus = [];
      for (let index = 0; index < filteredMenus.length; index++) {
        const menu = filteredMenus[index];
        for (let index2 = 0; index2 < menu.items.length; index2++) {
          const item = menu.items[index2];
          if (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 &&
            this.hasCurrentUserDocumentPermission(item.objectId, "isReadOnly")
          ) {
            menus.push({
              name: item.name,
              id: (item.type == "Form" ? "f" : "g") + "-" + item.objectId,
              isLeaf: true
            });
          }
        }
      }
      return menus;
    },
    sidebarItemsFilter() {
      const items = this.sidebarItems.filter(
        u => !u.condition || u.condition()
      );

      return this.search
        ? items.filter(
            item =>
              item.text.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          )
        : items;
    },
    statusVariant() {
      if (this.eoc) {
        switch (this.eoc.status) {
          case "Pending":
            return "warning";
          case "Active":
            return "success";
          case "Inactive":
            return "danger";
          default:
            return "";
        }
      }
      return "primary";
    },
    statusText() {
      if (this.eoc) {
        switch (this.eoc.status) {
          case "Pending":
            return "PENDING";
          case "Active":
            return "ACTIVE";
          case "Inactive":
            return "INACTIVE";
          default:
            return "";
        }
      }
      return "";
    }
  },
  watch: {
    "listeners.fetchDocumentMenus": function(newValue, oldValue) {
      if (newValue["all"] != oldValue["all"]) {
        this.refetchMenus = true;
      }
    },
    "listeners.fetchEoc": function(newValue, oldValue) {
      if (newValue[this.eocId] != oldValue[this.eocId]) {
        this.getClient();
      }
    },
    "listeners.fetchClient": function(newValue, oldValue) {
      if (newValue[this.clientId] != oldValue[this.clientId]) {
        this.getClient();
      }
    },
    showing: async function(newValue) {
      if (newValue && this.refetchMenus) {
        this.getMenus();
        this.refetchMenus = false;
      }
    }
  }
};
</script>

<style scoped>
.left-sidebar {
  width: 300px;
  overflow-y: auto;
}

.sidebar-menu-item {
  font-size: 14px;
  padding: 13px 15px;
}

.sidebar-menu-item-bottom {
  border-top: 2px solid;
}

.sidebar-menu-item:hover,
.sidebar-menu-item-bottom:hover {
  cursor: pointer;
  background-color: white;
}

.sidebar-menu-item-label {
  font-size: 14px;
}

.main-content {
  width: calc(100% - 300px);
  overflow-y: auto;
  overflow-x: hidden;
}

.client-data {
  font-size: 16px;
}

.border-width-2 {
  border-width: 2px !important;
}

.patient-top-bar-data {
  font-size: 13px;
}

.patient-top-bar-data-general {
  line-height: 16px;
  font-size: 20px;
}

.search-input {
  border-radius: 20px;
  padding-left: 20px;
}

.search-container {
  width: 290px;
  min-width: 290px;
  padding: 20px 17px;
}

.client-avatar {
  margin-left: 30px;
}

.status-badge {
  font-size: 10px;
}

.top-bar-container >>> .dropdown-menu {
  width: 220px;
  padding: 0;
}

.main-content >>> .left-white-border {
  height: calc(100vh - 232px);
  overflow: auto;
}
</style>
